import { fontColor } from "../styleProperties";

export default {
  methods: {
    getStyle(item) {
      const style = (item.inherit || false) ?  this.css : item;
      return {
        ...fontColor(style)
      };
    }
  }
}